module.exports = __webpack_public_path__ + "static/media/preview-2.beae1345.jpg";